import React from "react";
import { Link } from "react-router-dom";
import { Globe, Mail, Shield, ExternalLink } from "lucide-react";

const LOGO_URL = "https://cdn.gamma.app/40wtxlv020nnuu2/0bd85e15bbd243ca96d4ed4e00a0f4fa/original/HumaDash-Logo-3.4.25.png";
const HUMADASH_URL = process.env.REACT_APP_HUMADASH_URL || "https://humadash.com";
const HUMATEK_URL = process.env.REACT_APP_HUMATEK_URL || "https://humatek.io";

export const HumaTekFooter = () => {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="humatek-footer">
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img src={LOGO_URL} alt="HumaDash" className="h-8 w-auto" />
              <span className="font-heading font-bold text-lg text-slate-800">HumaDash</span>
            </div>
            <p className="text-sm text-slate-500 leading-relaxed">
              Enterprise-grade transparency platform for humanitarian aid distribution. Track every dollar from donation to impact.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h4 className="font-heading font-bold text-sm text-slate-800 mb-4 uppercase tracking-wider">Platform</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/public-dashboard" className="text-sm text-slate-500 hover:text-primary transition-colors">
                  Live Dashboard
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-sm text-slate-500 hover:text-primary transition-colors">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-sm text-slate-500 hover:text-primary transition-colors">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-bold text-sm text-slate-800 mb-4 uppercase tracking-wider">Company</h4>
            <ul className="space-y-2.5">
              <li>
                <a href={HUMATEK_URL} target="_blank" rel="noopener noreferrer" className="text-sm text-slate-500 hover:text-primary transition-colors inline-flex items-center gap-1">
                  HumaTek <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a href={HUMADASH_URL} target="_blank" rel="noopener noreferrer" className="text-sm text-slate-500 hover:text-primary transition-colors inline-flex items-center gap-1">
                  About HumaDash <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a href="mailto:info@humatek.io" className="text-sm text-slate-500 hover:text-primary transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Trust */}
          <div>
            <h4 className="font-heading font-bold text-sm text-slate-800 mb-4 uppercase tracking-wider">Trust & Security</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-slate-500">
                <Shield className="h-3.5 w-3.5 text-primary" />
                Blockchain-Verified Audit Trail
              </li>
              <li className="flex items-center gap-2 text-sm text-slate-500">
                <Globe className="h-3.5 w-3.5 text-primary" />
                Real-Time Global Tracking
              </li>
              <li className="flex items-center gap-2 text-sm text-slate-500">
                <Mail className="h-3.5 w-3.5 text-primary" />
                Automated Donor Receipts
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            &copy; 2026 HumaTek Holdings Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-slate-500">
            <a href={HUMADASH_URL} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
              Privacy Policy
            </a>
            <a href={HUMADASH_URL} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default HumaTekFooter;
